export interface ResponseI {
  status: number;
  message: string;
  data: any;
}

export const LessonScreenContentI = {
  FILES: "FILES",
  VIDEO: "VIDEO",
  QUIZ: "QUIZ",
  HW: "HW",
} as const;

export type LessonScreenContentI = keyof typeof LessonScreenContentI;

export interface LessonScreenI {
  elementId: string;
  screen: LessonScreenContentI;
}

export interface LessonI {
  lesson_id?: string;
  lesson_title: string;
  video_on_off: "yes" | "no";
  prod_grade?: number; // select input
  prod_cat: number; // select input
  price: number;
  allowed_views: number;
  allowed_time: number;
  last_purchase_date: string;
  prereq_type: "quiz" | "hw"; // select input
  prereq: string;
  payment_method_code: boolean; // checkbox input
  payment_method_fawry: boolean; // checkbox input
  hide_lesson_price: boolean; // checkbox input
  xvast_protection: boolean; // checkbox input
  quiz_required: boolean; // checkbox input
  quiz_id: string;
  hw_id: string;
  comments_or_hw: string;
  lessonFiles: {
    url: string;
    name: string;
    size: number;
    type: string;
  }[];
  videos: {
    video_host: "youtube" | "vimeo"; // default is youtube
    video_title: string;
    video_id: string;
    video_url: string;
    video_id2: string;
    video_url2: string;
  }[];
}
